import {
  DateField,
  EditActions,
  ReferenceField,
  Show,
  SimpleShowLayout,
  TextField,
} from "../common";

export const DepartmentShow = () => (
  <Show actions={<EditActions />}>
    <SimpleShowLayout>
      <TextField source="name" />
      <TextField source="code" />
      <ReferenceField source="head_employee_id" reference="employees">
        <TextField source="name" />
      </ReferenceField>
      <DateField source="created_at" showTime />
    </SimpleShowLayout>
  </Show>
);
